import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f3204fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "patient-card__header" }
const _hoisted_2 = { class: "patient-card__name text-medium" }
const _hoisted_3 = { class: "patient-card__count" }
const _hoisted_4 = { class: "patient-card__number" }

import { PropType } from 'vue'
import { PatientListingItemType } from '@/shared/types'


export default /*#__PURE__*/_defineComponent({
  props: {
  patient: Object as PropType<PatientListingItemType>,
  active: Boolean as PropType<boolean>,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'patient-card--active': __props.active }, "patient-card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(__props.patient.surname) + " " + _toDisplayString(__props.patient.name) + " " + _toDisplayString(__props.patient.patronymic ?? ''), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.patient.reports_count), 1)
    ]),
    _createElementVNode("p", _hoisted_4, "№ Медкарты: " + _toDisplayString(__props.patient.cart_number), 1)
  ], 2))
}
}

})